import { propertyAttributes } from 'bundles/research/index/research_constants';

export const requiredFields = [
  'address',
  'city',
  'state',
  'zip'
];

export const blacklistedFields = [
  'createdAt',
  'createdBy',
  'databaseId',
  'databaseName',
  'id',
  'lastUpdatedAt',
  'lastUpdatedBy',
  'modelType',
  'ownerType',
  'ownerUrl',
  'thumbnailUrl',
  'url'
];

export function shouldDisplayRow(
  properties: Record<string, any>[],
  propertyDefaults: Record<string, any>,
  key: string
): boolean {
  if (properties.length === 0 || blacklistedFields.includes(key)) {
    return false;
  }

  const firstProperty = properties[0];
  const value =
    Array.isArray(firstProperty[key])
      ? firstProperty[key].toString()
      : firstProperty[key];

  let retVal = false;
  const defaultVal = propertyDefaults[key];

  properties.map((property, index) => {
    const val = Array.isArray(property[key]) ? property[key].toString() : property[key];
    let isDefault;

    if (!defaultVal) {
      isDefault = [null, '', '--'].includes(val);
    } else {
      isDefault = val === defaultVal;
    }

    if (index > 0 && (value !== val || !isDefault) && value && val) {
      retVal = true;
    }
  });
  return retVal;
}

export function displayedKeys(
  properties: Record<string, any>[],
  propertyDefaults: Record<string, any>,
  attributes: string[] = propertyAttributes
): string[] {
  return attributes.filter(key => shouldDisplayRow(properties, propertyDefaults, key));
}

export function allRequiredSelected(
  attributesMap: Record<string, number | null>,
  shownKeys: string[],
  required: string[] = requiredFields
): boolean {
  return required.every(field => !shownKeys.includes(field) || attributesMap[field] != null);
}
